export const ROUTE_PAGE_NAME = "ROUTE_PAGE_NAME"

export const routePageName = (data) => ({
	type: ROUTE_PAGE_NAME,
	data: data,
})
